// extracted by mini-css-extract-plugin
export default {"register":"styles_register__Nm2B3","divider":"styles_divider__Lr82q","radioText":"styles_radioText__Eut5M"};